import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router';
import { attachDocumentMetaToRouter } from '@/utils/seo';

const LandingPage = () => import('@/views/LandingPage.vue');
const CatalogoProductos = () => import('@/views/CatalogoProductos.vue');
const CatalogoAmazon = () => import('@/views/CatalogoAmazon.vue');
const DetalleProducto = () => import('@/views/DetalleProducto.vue');
const ValidarCarrito = () => import('@/views/ValidarCarrito.vue');
const DetallePublicacion = () => import('@/views/DetallePublicacion.vue');
const PerfilUsuario = () => import('@/views/PerfilUsuario.vue');
const LoginTienda = () => import('@/views/LoginTienda.vue');
const RegistroUsuario = () => import('@/views/RegistroUsuario.vue');
const RecuperarContrasena = () => import('@/views/RecuperarContrasena.vue');
const FinalizarCompra = () => import('@/views/FinalizarCompra.vue');
const ContactoTienda = () => import('@/views/ContactoTienda.vue');
const TrabajaConNosotros = () => import('@/views/TrabajaConNosotros.vue');
const CVMat = () => import('@/views/CVMat.vue');
const NosotrosPage = () => import('@/views/NosotosPage.vue');
const HistoriaDestacados = () => import('@/views/HistoriaDestacados.vue');
const GraciasCompra = () => import('@/views/GraciasCompra.vue');
const LinkClienteReserva = () => import('@/views/LinkClienteReserva.vue');
const LinkClientePromo = () => import('@/views/LinkClientePromo.vue');

/** Textos largos (title, description) viven en `src/locales/es-CL.json` / `en.json` bajo `routes.<name>`. */

const routes = [
  {
    path: '/home',
    name: 'LandingHome',
    component: LandingPage,
    meta: {
      requiresAuth: false,
      icon: 'pi pi-home',
      name: 'Inicio',
      title: 'Inicio',
      showBreadcrumb: false,
    },
  },
  {
    path: '/historia-destacados',
    name: 'historia-destacados',
    component: HistoriaDestacados,
    meta: {
      requiresAuth: false,
      icon: 'pi pi-book',
      name: 'Historias destacadas',
      title: 'Historias destacadas',
      showBreadcrumb: true,
    },
  },
  {
    path: '/',
    name: 'LandingInicio',
    component: LandingPage,
    meta: {
      requiresAuth: false,
      icon: 'pi pi-home',
      name: 'Inicio',
      title: 'Inicio',
      showBreadcrumb: false,
    },
  },
  {
    path: '/login',
    name: 'LoginTienda',
    component: LoginTienda,
    meta: {
      noRequiereAutenticacion: false,
      icon: 'pi pi-id-card',
      name: 'Iniciar sesión',
      title: 'Iniciar sesión',
      showBreadcrumb: false,
    },
  },
  {
    path: '/catalogo-productos',
    name: 'CatalogoProductos',
    component: CatalogoProductos,
    meta: {
      noRequiereAutenticacion: true,
      icon: 'pi pi-list',
      name: 'Catálogo',
      title: 'Catálogo de productos',
      showBreadcrumb: true,
    },
  },
  {
    path: '/catalogo-amazon',
    name: 'catalogo-amazon',
    component: CatalogoAmazon,
    meta: {
      noRequiereAutenticacion: true,
      icon: 'pi pi-list',
      name: 'Catálogo Amazon',
      title: 'Catálogo Amazon',
      showBreadcrumb: true,
    },
  },
  {
    path: '/nosotros',
    name: 'nosotros',
    component: NosotrosPage,
    meta: {
      noRequiereAutenticacion: true,
      icon: 'pi pi-users',
      name: 'Nosotros',
      title: 'Nosotros',
      showBreadcrumb: true,
    },
  },
  {
    path: '/producto/:id',
    name: 'producto',
    component: DetalleProducto,
    props: true,
    meta: {
      noRequiereAutenticacion: true,
      icon: 'pi pi-shopping-bag',
      name: 'Producto',
      title: 'Detalle de producto',
      showBreadcrumb: true,
    },
  },
  {
    path: '/validar-carrito',
    name: 'ValidarCarrito',
    component: ValidarCarrito,
    meta: {
      noRequiereAutenticacion: false,
      icon: 'pi pi-shopping-cart',
      name: 'Carrito',
      title: 'Carrito de compras',
      showBreadcrumb: true,
    },
  },
  {
    path: '/publicacion/:id',
    name: 'publicacion',
    component: DetallePublicacion,
    meta: {
      noRequiereAutenticacion: false,
      icon: 'pi pi-book',
      name: 'Publicación',
      title: 'Publicación',
      showBreadcrumb: true,
    },
  },
  {
    path: '/perfil-usuario',
    name: 'PerfilUsuario',
    component: PerfilUsuario,
    meta: {
      noRequiereAutenticacion: false,
      icon: 'pi pi-id-card',
      name: 'Mi perfil',
      title: 'Mi perfil',
      showBreadcrumb: true,
    },
  },
  {
    path: '/registro',
    name: 'RegistroUsuario',
    component: RegistroUsuario,
    meta: {
      noRequiereAutenticacion: false,
      icon: 'pi pi-user-plus',
      name: 'Registro',
      title: 'Crear cuenta',
      showBreadcrumb: true,
    },
  },
  {
    path: '/recuperar-contrasena',
    name: 'RecuperarContrasena',
    component: RecuperarContrasena,
    meta: {
      noRequiereAutenticacion: false,
      icon: 'pi pi-key',
      name: 'Recuperar contraseña',
      title: 'Recuperar contraseña',
      showBreadcrumb: true,
    },
  },
  {
    path: '/finalizar-compra',
    name: 'FinalizarCompra',
    component: FinalizarCompra,
    meta: {
      noRequiereAutenticacion: false,
      icon: 'pi pi-credit-card',
      name: 'Finalizar compra',
      title: 'Finalizar compra',
      showBreadcrumb: true,
    },
  },
  {
    path: '/gracias-compra',
    name: 'GraciasCompra',
    component: GraciasCompra,
    meta: {
      icon: 'pi pi-check-circle',
      name: 'Compra registrada',
      title: 'Gracias por tu compra',
      showBreadcrumb: true,
    },
  },
  {
    path: '/contacto',
    name: 'Contacto',
    component: ContactoTienda,
    meta: {
      icon: 'pi pi-envelope',
      name: 'Contacto',
      title: 'Contacto',
      showBreadcrumb: true,
    },
  },
  {
    path: '/trabaja-con-nosotros',
    name: 'TrabajaConNosotros',
    component: TrabajaConNosotros,
    meta: {
      icon: 'pi pi-briefcase',
      name: 'Trabaja con nosotros',
      title: 'Trabaja con nosotros',
      showBreadcrumb: true,
    },
  },
  {
    path: '/cv-mat',
    name: 'cv-mat',
    component: CVMat,
    meta: {
      requiresAuth: false,
      icon: 'pi pi-file',
      name: 'CV',
      title: 'CV',
      showBreadcrumb: false,
    },
  },
  {
    path: '/pedido-cliente/:publicToken',
    name: 'PedidoClienteLink',
    component: LinkClienteReserva,
    props: true,
    meta: {
      layoutPedidoCliente: true,
      requiresAuth: false,
      icon: 'pi pi-link',
      name: 'Pedido por enlace',
      title: 'Pedido por enlace',
      showBreadcrumb: false,
    },
  },
  {
    path: '/link-cliente-promo/:slug/:token',
    name: 'LinkClientePromo',
    component: LinkClientePromo,
    props: true,
    meta: {
      layoutPedidoCliente: true,
      requiresAuth: false,
      icon: 'pi pi-gift',
      name: 'Promo referido',
      title: 'Promoción referida',
      showBreadcrumb: false,
    },
  },
  {
    path: '/link-cliente/:publicToken',
    redirect: (to) => ({
      name: 'PedidoClienteLink',
      params: { publicToken: to.params.publicToken },
    }),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
    meta: {
      icon: 'pi pi-compass',
      name: 'No encontrada',
      title: 'Página no encontrada',
      showBreadcrumb: true,
    },
  },
];

const useHashHistory =
  String(process.env.VUE_APP_ROUTER_MODE || '').toLowerCase() === 'hash';

const router = createRouter({
  history: useHashHistory
    ? createWebHashHistory(process.env.BASE_URL)
    : createWebHistory(process.env.BASE_URL),
  routes,
});

attachDocumentMetaToRouter(router);

export default router;
